if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        const viewAllButton = this.parentElement?.querySelector('.collapsible-tabs__view-all-button');
        if (viewAllButton && !viewAllButton.dataset.initialized) {
          viewAllButton.dataset.initialized = 'true';
          viewAllButton.addEventListener('click', () => {
            this.querySelectorAll('.collapsible-tabs__item--hidden').forEach((item) => {
              item.classList.remove('hidden');
              item.classList.remove('collapsible-tabs__item--hidden');

              const details = item.querySelector('.accordion-details');
              if (details && !details.open) {
                this.handleClose(details);
              }
            });
            viewAllButton.closest('.collapsible-tabs__view-all')?.remove();
          });
        }
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
